import styled, { css } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken, Inlined, Sized, Status } from '@optimus-web/common';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/local-tokens';
import { getBorderColor, getTextColor } from './getFieldStyles';

export const FieldContainer = styled.div`
    text-align: left;
`;

export const FieldHeader = styled.div<Inlined & Sized>`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${(props) =>
        props.size === 'large'
            ? `${getToken(TokenName.SPACING_100)(props)}px`
            : `${getToken(TokenName.SPACING_50)(props)}px`};
`;

export const Caption = styled.div`
    ${getTextTokenPreset('BODY_M')};
    color: ${getToken(TokenName.TEXT_STATIC_SECONDARY)};
`;

export const FieldIconButtonWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export interface InputWrapperProps extends Sized {
    $disabled?: boolean;
    focused?: boolean;
    status?: Status;
    error?: boolean;
}

export const FieldInputWrapper = styled.div<InputWrapperProps>`
    border-width: ${getToken(TokenName.BORDER_WIDTH_150)}px;
    border-style: solid;
    border-color: ${(props) => getBorderColor(props)};
    color: ${(props) => getTextColor(props)};
    background: ${({ $disabled }) =>
        $disabled ? getToken(TokenName.BACKGROUND_DISABLED) : getToken(TokenName.BACKGROUND_STATIC_FLAT)};
    display: flex;
    justify-content: center;
    border-radius: ${getToken(TokenName.BORDER_RADIUS_100)}px;
    box-sizing: border-box;
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-property: border-color;
    transition-timing-function: ${ANIMATION_CURVE.default};

    &:hover {
        ${({ $disabled, error, focused }) =>
            !focused &&
            !$disabled &&
            !error &&
            css`
                border-color: ${getToken(TokenName.BORDER_INTERACTIVE_SECONDARY_HOVER)};
            `}
    }
`;
